import { Amount } from "@/components";
import { colors } from "@/styles/colors";
import { Icon } from "@/ui";
import { FunctionComponent, ReactElement } from "react";
import styles from "./IncomeSource.module.scss";
import { IIncomeSourceProps } from "./types";

export const IncomeSource: FunctionComponent<IIncomeSourceProps> = (
  props: IIncomeSourceProps
): ReactElement<IIncomeSourceProps> => {
  const { incomeSource, ...restProps } = props;

  return (
    <div {...restProps}>
      <div className="blockLine">
        <h2>{incomeSource.name}</h2>
      </div>
      <div className="fullCard mainBlockBg shadowCard marginBottom">
        <div className="smallCard marginBottom">
          <Icon
            backgroundColor={incomeSource.color}
            className={styles.iconDefault}
            color={colors.palette.white}
            icon={incomeSource.icon}
            size={32}
          />
          <div className="cardContent">
            <Amount
              className="cardContentValue"
              currency={incomeSource.currency}
              value={incomeSource.balance}
            />
            <Amount
              currency={incomeSource.currency}
              value={incomeSource.limitation}
              renderText={(formattedvalue) => (
                <span className="cardContentLabel">{`из ${formattedvalue}`}</span>
              )}
            />
          </div>
        </div>
        {false && (
          <ul className="btnGroupHorizontal">
            <li className="btnGroupHorizontalLi">
              <a
                href="#"
                className="mainBtn"
                onClick={() => console.log("twoLevelModal(addIncome);")}
              >
                Внести доход
              </a>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};
